import { Grid, Typography } from '@mui/material';

export type TabGridStructure = {
  label: string;
  content: string | JSX.Element;
};
interface TabGridProps {
  data: TabGridStructure[];
  colWidth?: number;
}
export const TabGrid = ({ data, colWidth = 4 }: TabGridProps) => {
  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={4}>
      {data.map(({ label, content }) => (
        <Grid item xs={12} md={colWidth} key={label}>
          <Typography variant="subtitle2" sx={{ color: '#666' }}>
            {label}
          </Typography>
          {typeof content === 'string' ? (
            <Typography variant="body1" sx={{ wordBreak: 'break-word', hyphens: 'auto' }}>
              {content}
            </Typography>
          ) : content}
        </Grid>
      ))}
    </Grid>
  );
};
